import {getToken,removeToken,refreshesToken} from "./auth"
/**
 * 格式化日期
 * @date 2018/12/25
 * @param {Number} index 1-year,2-month,3-date,4-hour,5-minute,6-second,else-yyyy-mm-dd
 * @param {String} fmt 
 * @param {String} str 
 * @returns {String}
 */
export function formateDate(index,fmt,str){
    var date = str ?  new Date(str) : new Date();
    var d = {
        Y: date.getFullYear(),
        M: date.getMonth()+1,
        D: date.getDate(),
        h: date.getHours(),
        m: date.getMinutes(),
        s: date.getSeconds()
    };
    fmt = fmt ? fmt : "YYYY-MM-DD";
    for(var i in d){
        if(new RegExp("("+i+")").test(fmt)){
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (d[i]) : (("00"+ d[i]).substr((""+ d[i]).length)) );
        }
    }
    var str = index == 1 ? d.Y :index==2 ? d.M:index==3?d.D:index==4?d.h: index==5? d.m: index==6? d.s: fmt;
    return str; 
}
/**
 * 将字符串转换成*
 * @date 2019/5/14
 * @export
 * @param {String} str 
 * @returns 
 */
export function encrypt(str){
    var res = "";
    if(str.toString()){
        str = str.toString();
    }
    for(var i=0; i<str.length; i++){
        res += "*";
    } 
    return res;
}

/**
 * 获取css样式
 * @date 2019/5/28
 * @export
 * @param {Object} obj 
 * @param {String} attribute 
 * @returns 
 */
export function getCss(obj, attribute) {
    if (obj.currentStyle) {
        return obj.currentStyle[attribute];
    } else {
        return window.getComputedStyle(obj, null)[attribute];
    }
}

/**
 * base64转file
 * @date 2019/7/5
 * @export
 * @param {any} dataurl 
 * @param {any} fileName 
 * @returns 
 */
export function dataUrlToFile(dataurl,fileName){
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    let blob = new Blob([u8arr], { type: mime });
    blob.lastModifiedDate  = new Date();
    blob.name = fileName;
    return blob;
}

export function getRemember(){
    return localStorage.getItem("isRemember");
}

/**
 * 验证登录信息
 * 
 * @export
 */
export async function justifyInfo(){
    let token = getToken();
    let userInfo = localStorage.getItem('userInfo');
    if(token){
        if(!userInfo){
            await refreshesToken();
        }
    }else{
        localStorage.removeItem('userInfo');
        removeToken();
    }
} 
 
/**
 * 合并两个数组并去重
 * 
 * @export
 * @param {any} arr1 
 * @param {any} arr2 
 */
export function concat(arr1,arr2){
    var arr = arr1.concat();
    for(var i=0;i<arr2.length;i++){
        arr.indexOf(arr2[i]) === -1 ? arr.unshift(arr2[i]) : 0;
    }
    return arr;
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/utils.js